// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var TypeUtils = require("../../../shared/src/types/TypeUtils.bs.js");
var UrlHelpers = require("../../../shared/src/UrlHelpers.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Relude_List = require("relude/src/Relude_List.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var Relude_Function = require("relude/src/Relude_Function.bs.js");
var CommonTypes_Guid = require("../../../shared/src/types/CommonTypes_Guid.bs.js");
var CommonTypes_Shift = require("../../../shared/src/types/CommonTypes_Shift.bs.js");
var CommonTypes_UTMParams = require("../../../shared/src/types/CommonTypes_UTMParams.bs.js");
var WebTypes_BusinessAdmin = require("./WebTypes_BusinessAdmin.bs.js");
var CommonTypes_MobileDeepLink = require("../../../shared/src/types/CommonTypes_MobileDeepLink.bs.js");
var CommonTypes_Business_Manager = require("../../../shared/src/types/business/CommonTypes_Business_Manager.bs.js");
var CommonTypes_Business_Location = require("../../../shared/src/types/business/CommonTypes_Business_Location.bs.js");
var CommonTypes_Business_PromoCode = require("../../../shared/src/types/business/CommonTypes_Business_PromoCode.bs.js");
var CommonTypes_Worker_ReferralPromoCode = require("../../../shared/src/types/worker/CommonTypes_Worker_ReferralPromoCode.bs.js");

function eq(param, param$1) {
  return Relude_Function.curry2((function (param) {
                var a = param[0];
                if (typeof a === "number") {
                  if (a === /* Viewing */0) {
                    var match = param[1];
                    if (typeof match === "number") {
                      return match === 0;
                    } else {
                      return false;
                    }
                  }
                  var match$1 = param[1];
                  if (typeof match$1 === "number") {
                    return match$1 !== 0;
                  } else {
                    return false;
                  }
                } else {
                  if (a.TAG === /* Editing */0) {
                    var b = param[1];
                    if (typeof b === "number" || b.TAG !== /* Editing */0) {
                      return false;
                    } else {
                      return Curry._2(WebTypes_BusinessAdmin.Id.eq, a._0, b._0);
                    }
                  }
                  var b$1 = param[1];
                  if (typeof b$1 === "number" || b$1.TAG !== /* Removing */1) {
                    return false;
                  } else {
                    return Curry._2(WebTypes_BusinessAdmin.Id.eq, a._0, b$1._0);
                  }
                }
              }), param, param$1);
}

var Admins = {
  eq: eq
};

function eq$1(param, param$1) {
  return Relude_Function.curry2((function (param) {
                var a = param[0];
                if (typeof a === "number") {
                  if (a === /* Viewing */0) {
                    var match = param[1];
                    if (typeof match === "number") {
                      return match === 0;
                    } else {
                      return false;
                    }
                  }
                  var match$1 = param[1];
                  if (typeof match$1 === "number") {
                    return match$1 !== 0;
                  } else {
                    return false;
                  }
                } else {
                  if (a.TAG === /* Editing */0) {
                    var b = param[1];
                    if (typeof b === "number" || b.TAG !== /* Editing */0) {
                      return false;
                    } else {
                      return Curry._2(CommonTypes_Business_Manager.Id.eq, a._0, b._0);
                    }
                  }
                  var b$1 = param[1];
                  if (typeof b$1 === "number" || b$1.TAG !== /* Removing */1) {
                    return false;
                  } else {
                    return Curry._2(CommonTypes_Business_Manager.Id.eq, a._0, b$1._0);
                  }
                }
              }), param, param$1);
}

var Managers = {
  eq: eq$1
};

function eq$2(param, param$1) {
  return Relude_Function.curry2((function (param) {
                var a = param[0];
                if (typeof a === "number") {
                  if (a === /* Viewing */0) {
                    var match = param[1];
                    if (typeof match === "number") {
                      return match === 0;
                    } else {
                      return false;
                    }
                  }
                  var match$1 = param[1];
                  if (typeof match$1 === "number") {
                    return match$1 !== 0;
                  } else {
                    return false;
                  }
                } else {
                  if (a.TAG === /* Editing */0) {
                    var b = param[1];
                    if (typeof b === "number" || b.TAG !== /* Editing */0) {
                      return false;
                    } else {
                      return Curry._2(CommonTypes_Business_Location.Id.eq, a._0, b._0);
                    }
                  }
                  var b$1 = param[1];
                  if (typeof b$1 === "number" || b$1.TAG !== /* Removing */1) {
                    return false;
                  } else {
                    return Curry._2(CommonTypes_Business_Location.Id.eq, a._0, b$1._0);
                  }
                }
              }), param, param$1);
}

var Locations = {
  eq: eq$2
};

function admins(param_0) {
  return {
          TAG: /* Admins */0,
          _0: param_0
        };
}

function managers(param_0) {
  return {
          TAG: /* Managers */1,
          _0: param_0
        };
}

function locations(param_0) {
  return {
          TAG: /* Locations */2,
          _0: param_0
        };
}

function eq$3(param, param$1) {
  return Relude_Function.curry2((function (param) {
                var a = param[0];
                switch (a.TAG | 0) {
                  case /* Admins */0 :
                      var b = param[1];
                      switch (b.TAG | 0) {
                        case /* Admins */0 :
                            return eq(a._0, b._0);
                        case /* Managers */1 :
                        case /* Locations */2 :
                            return false;
                        
                      }
                  case /* Managers */1 :
                      var b$1 = param[1];
                      switch (b$1.TAG | 0) {
                        case /* Managers */1 :
                            return eq$1(a._0, b$1._0);
                        case /* Admins */0 :
                        case /* Locations */2 :
                            return false;
                        
                      }
                  case /* Locations */2 :
                      var b$2 = param[1];
                      switch (b$2.TAG | 0) {
                        case /* Admins */0 :
                        case /* Managers */1 :
                            return false;
                        case /* Locations */2 :
                            return eq$2(a._0, b$2._0);
                        
                      }
                  
                }
              }), param, param$1);
}

function toUrlParts(param) {
  switch (param.TAG | 0) {
    case /* Admins */0 :
        return {
                path: {
                  hd: "admins",
                  tl: /* [] */0
                },
                queryArgs: /* [] */0
              };
    case /* Managers */1 :
        return {
                path: {
                  hd: "managers",
                  tl: /* [] */0
                },
                queryArgs: /* [] */0
              };
    case /* Locations */2 :
        return {
                path: {
                  hd: "locations",
                  tl: /* [] */0
                },
                queryArgs: /* [] */0
              };
    
  }
}

function fromUrlParts(param) {
  var match = param.path;
  if (!match) {
    return {
            TAG: /* Admins */0,
            _0: /* Viewing */0
          };
  }
  switch (match.hd) {
    case "admins" :
        return {
                TAG: /* Admins */0,
                _0: /* Viewing */0
              };
    case "locations" :
        if (match.tl) {
          return {
                  TAG: /* Admins */0,
                  _0: /* Viewing */0
                };
        } else {
          return {
                  TAG: /* Locations */2,
                  _0: /* Viewing */0
                };
        }
    case "managers" :
        if (match.tl) {
          return {
                  TAG: /* Admins */0,
                  _0: /* Viewing */0
                };
        } else {
          return {
                  TAG: /* Managers */1,
                  _0: /* Viewing */0
                };
        }
    default:
      return {
              TAG: /* Admins */0,
              _0: /* Viewing */0
            };
  }
}

var Settings = {
  Admins: Admins,
  Managers: Managers,
  Locations: Locations,
  admins: admins,
  managers: managers,
  locations: locations,
  eq: eq$3,
  toUrlParts: toUrlParts,
  fromUrlParts: fromUrlParts
};

function toEnum(param) {
  if (param !== 0) {
    if (param !== 1) {
      return ;
    } else {
      return /* Past */0;
    }
  } else {
    return /* Upcoming */1;
  }
}

function fromEnum(param) {
  if (param) {
    return 0;
  } else {
    return 1;
  }
}

var include = TypeUtils.TypeClasses.WithGenerateable({
      startingIndex: 0,
      fromEnum: fromEnum,
      toEnum: toEnum
    });

var eq$4 = include.eq;

function toString(param) {
  if (param) {
    return "upcoming";
  } else {
    return "past";
  }
}

function fromString(param) {
  return Relude_Globals.$great$great(Relude_String.toLowerCase, (function (param) {
                switch (param) {
                  case "past" :
                      return /* Past */0;
                  case "upcoming" :
                      return /* Upcoming */1;
                  default:
                    return ;
                }
              }), param);
}

var ShiftsList_fromEnum = include.fromEnum;

var ShiftsList_toEnum = include.toEnum;

var ShiftsList_compare = include.compare;

var ShiftsList_Ord = include.Ord;

var ShiftsList_compareWithConversion = include.compareWithConversion;

var ShiftsList_compareReversed = include.compareReversed;

var ShiftsList_OrdReversed = include.OrdReversed;

var ShiftsList_compareAsInt = include.compareAsInt;

var ShiftsList_min = include.min;

var ShiftsList_max = include.max;

var ShiftsList_lessThan = include.lessThan;

var ShiftsList_lt = include.lt;

var ShiftsList_lessThanOrEq = include.lessThanOrEq;

var ShiftsList_lte = include.lte;

var ShiftsList_greaterThan = include.greaterThan;

var ShiftsList_gt = include.gt;

var ShiftsList_greaterThanOrEq = include.greaterThanOrEq;

var ShiftsList_gte = include.gte;

var ShiftsList_clamp = include.clamp;

var ShiftsList_between = include.between;

var ShiftsList_OrdRingExtensions = include.OrdRingExtensions;

var ShiftsList_OrdNamed = include.OrdNamed;

var ShiftsList_OrdBy = include.OrdBy;

var ShiftsList_Set = include.$$Set;

var ShiftsList_SetWithNone = include.SetWithNone;

var ShiftsList_Map = include.$$Map;

var ShiftsList_list = include.list;

var ShiftsList_array = include.array;

var ShiftsList_set = include.set;

var ShiftsList_setWithNone = include.setWithNone;

var ShiftsList_cardinality = include.cardinality;

var ShiftsList_top = include.top;

var ShiftsList_bottom = include.bottom;

var ShiftsList_succ = include.succ;

var ShiftsList_pred = include.pred;

var ShiftsList = {
  fromEnum: ShiftsList_fromEnum,
  toEnum: ShiftsList_toEnum,
  eq: eq$4,
  compare: ShiftsList_compare,
  Ord: ShiftsList_Ord,
  compareWithConversion: ShiftsList_compareWithConversion,
  compareReversed: ShiftsList_compareReversed,
  OrdReversed: ShiftsList_OrdReversed,
  compareAsInt: ShiftsList_compareAsInt,
  min: ShiftsList_min,
  max: ShiftsList_max,
  lessThan: ShiftsList_lessThan,
  lt: ShiftsList_lt,
  lessThanOrEq: ShiftsList_lessThanOrEq,
  lte: ShiftsList_lte,
  greaterThan: ShiftsList_greaterThan,
  gt: ShiftsList_gt,
  greaterThanOrEq: ShiftsList_greaterThanOrEq,
  gte: ShiftsList_gte,
  clamp: ShiftsList_clamp,
  between: ShiftsList_between,
  OrdRingExtensions: ShiftsList_OrdRingExtensions,
  OrdNamed: ShiftsList_OrdNamed,
  OrdBy: ShiftsList_OrdBy,
  $$Set: ShiftsList_Set,
  SetWithNone: ShiftsList_SetWithNone,
  $$Map: ShiftsList_Map,
  list: ShiftsList_list,
  array: ShiftsList_array,
  set: ShiftsList_set,
  setWithNone: ShiftsList_setWithNone,
  cardinality: ShiftsList_cardinality,
  top: ShiftsList_top,
  bottom: ShiftsList_bottom,
  succ: ShiftsList_succ,
  pred: ShiftsList_pred,
  toString: toString,
  fromString: fromString
};

function payTips(param_0) {
  return /* PayTips */{
          _0: param_0
        };
}

function eq$5(_a, _b) {
  return true;
}

var partial_arg = {
  path: /* [] */0,
  queryArgs: /* [] */0
};

function toUrlParts$1(param) {
  return Relude_Option.fold(partial_arg, (function (param) {
                var shiftId = param._0;
                if (shiftId !== undefined) {
                  return {
                          path: {
                            hd: "pay-tips",
                            tl: {
                              hd: Curry._1(CommonTypes_Shift.Id.toString, Caml_option.valFromOption(shiftId)),
                              tl: /* [] */0
                            }
                          },
                          queryArgs: /* [] */0
                        };
                } else {
                  return {
                          path: {
                            hd: "pay-tips",
                            tl: /* [] */0
                          },
                          queryArgs: /* [] */0
                        };
                }
              }), param);
}

function fromUrlParts$1(param) {
  var match = param.path;
  if (!match) {
    return /* PayTips */{
            _0: undefined
          };
  }
  if (match.hd !== "pay-tips") {
    return /* PayTips */{
            _0: undefined
          };
  }
  var match$1 = match.tl;
  if (match$1 && !match$1.tl) {
    return /* PayTips */{
            _0: Curry._1(CommonTypes_Shift.Id.fromString, match$1.hd)
          };
  } else {
    return /* PayTips */{
            _0: undefined
          };
  }
}

var ToDo = {
  payTips: payTips,
  eq: eq$5,
  toUrlParts: toUrlParts$1,
  fromUrlParts: fromUrlParts$1
};

function settings(param_0) {
  return {
          TAG: /* Settings */0,
          _0: param_0
        };
}

function shiftsList(param_0) {
  return {
          TAG: /* ShiftsList */1,
          _0: param_0
        };
}

function toDo(param_0) {
  return {
          TAG: /* ToDo */2,
          _0: param_0
        };
}

function eq$6(param, param$1) {
  return Relude_Function.curry2((function (param) {
                var a = param[0];
                if (typeof a === "number") {
                  if (typeof param[1] === "number") {
                    return true;
                  } else {
                    return false;
                  }
                }
                switch (a.TAG | 0) {
                  case /* Settings */0 :
                      var b = param[1];
                      if (typeof b === "number" || b.TAG !== /* Settings */0) {
                        return false;
                      } else {
                        return eq$3(a._0, b._0);
                      }
                  case /* ShiftsList */1 :
                      var b$1 = param[1];
                      if (typeof b$1 === "number" || b$1.TAG !== /* ShiftsList */1) {
                        return false;
                      } else {
                        return Curry._2(eq$4, a._0, b$1._0);
                      }
                  case /* ToDo */2 :
                      var tmp = param[1];
                      if (typeof tmp === "number" || tmp.TAG !== /* ToDo */2) {
                        return false;
                      } else {
                        return true;
                      }
                  
                }
              }), param, param$1);
}

function toUrlParts$2(page) {
  if (typeof page === "number") {
    return {
            path: {
              hd: "payments",
              tl: /* [] */0
            },
            queryArgs: /* [] */0
          };
  }
  switch (page.TAG | 0) {
    case /* Settings */0 :
        return UrlHelpers.UrlParts.prepend(toUrlParts(page._0), {
                    path: {
                      hd: "settings",
                      tl: /* [] */0
                    },
                    queryArgs: /* [] */0
                  });
    case /* ShiftsList */1 :
        if (page._0) {
          return {
                  path: {
                    hd: "upcoming",
                    tl: /* [] */0
                  },
                  queryArgs: /* [] */0
                };
        } else {
          return {
                  path: {
                    hd: "past",
                    tl: /* [] */0
                  },
                  queryArgs: /* [] */0
                };
        }
    case /* ToDo */2 :
        return UrlHelpers.UrlParts.prepend(Curry._1(toUrlParts$1, page._0), {
                    path: {
                      hd: "todo",
                      tl: /* [] */0
                    },
                    queryArgs: /* [] */0
                  });
    
  }
}

function fromUrlParts$2(param) {
  var match = param.path;
  if (!match) {
    return {
            TAG: /* ShiftsList */1,
            _0: /* Upcoming */1
          };
  }
  switch (match.hd) {
    case "past" :
        if (match.tl) {
          return {
                  TAG: /* ShiftsList */1,
                  _0: /* Upcoming */1
                };
        } else {
          return {
                  TAG: /* ShiftsList */1,
                  _0: /* Past */0
                };
        }
    case "payments" :
        if (match.tl) {
          return {
                  TAG: /* ShiftsList */1,
                  _0: /* Upcoming */1
                };
        } else {
          return /* Payments */0;
        }
    case "settings" :
        var path = match.tl;
        if (path) {
          return {
                  TAG: /* Settings */0,
                  _0: fromUrlParts({
                        path: path,
                        queryArgs: param.queryArgs
                      })
                };
        } else {
          return {
                  TAG: /* Settings */0,
                  _0: {
                    TAG: /* Admins */0,
                    _0: /* Viewing */0
                  }
                };
        }
    case "todo" :
        var path$1 = match.tl;
        if (path$1) {
          return {
                  TAG: /* ToDo */2,
                  _0: Relude_Option.pure(fromUrlParts$1({
                            path: path$1,
                            queryArgs: param.queryArgs
                          }))
                };
        } else {
          return {
                  TAG: /* ToDo */2,
                  _0: undefined
                };
        }
    case "upcoming" :
        return {
                TAG: /* ShiftsList */1,
                _0: /* Upcoming */1
              };
    default:
      return {
              TAG: /* ShiftsList */1,
              _0: /* Upcoming */1
            };
  }
}

var BusinessDashboard = {
  Settings: Settings,
  ShiftsList: ShiftsList,
  ToDo: ToDo,
  payments: /* Payments */0,
  settings: settings,
  shiftsList: shiftsList,
  toDo: toDo,
  eq: eq$6,
  toUrlParts: toUrlParts$2,
  fromUrlParts: fromUrlParts$2
};

function toUrlParts$3(param) {
  if (param) {
    return {
            path: {
              hd: "pro",
              tl: /* [] */0
            },
            queryArgs: /* [] */0
          };
  } else {
    return {
            path: {
              hd: "biz",
              tl: /* [] */0
            },
            queryArgs: /* [] */0
          };
  }
}

function fromUrlParts$3(param) {
  var match = param.path;
  if (!match) {
    return /* Professional */1;
  }
  switch (match.hd) {
    case "biz" :
        if (match.tl) {
          return /* Professional */1;
        } else {
          return /* Business */0;
        }
    case "pro" :
        return /* Professional */1;
    default:
      return /* Professional */1;
  }
}

var GetApp = {
  toUrlParts: toUrlParts$3,
  fromUrlParts: fromUrlParts$3
};

function toUrlParts$4(param) {
  switch (param) {
    case /* Business */0 :
        return {
                path: {
                  hd: "business",
                  tl: /* [] */0
                },
                queryArgs: /* [] */0
              };
    case /* ForgotPassword */1 :
        return {
                path: {
                  hd: "forgot-password",
                  tl: /* [] */0
                },
                queryArgs: /* [] */0
              };
    case /* Unknown */2 :
        return {
                path: /* [] */0,
                queryArgs: /* [] */0
              };
    
  }
}

function fromUrlParts$4(param) {
  var match = param.path;
  if (!match) {
    return /* Unknown */2;
  }
  switch (match.hd) {
    case "business" :
        if (match.tl) {
          return /* Unknown */2;
        } else {
          return /* Business */0;
        }
    case "forgot-password" :
        if (match.tl) {
          return /* Unknown */2;
        } else {
          return /* ForgotPassword */1;
        }
    default:
      return /* Unknown */2;
  }
}

var Login = {
  toUrlParts: toUrlParts$4,
  fromUrlParts: fromUrlParts$4
};

var Business = {};

var Professional = {};

var Signup = {
  Business: Business,
  Professional: Professional
};

function businessDashboard(param_0) {
  return {
          TAG: /* BusinessDashboard */0,
          _0: param_0
        };
}

function editShift(param_0) {
  return {
          TAG: /* EditShift */1,
          _0: param_0
        };
}

function getApp(param_0) {
  return {
          TAG: /* GetApp */2,
          _0: param_0
        };
}

function login(param_0) {
  return {
          TAG: /* Login */3,
          _0: param_0
        };
}

function postAShift(param_0) {
  return {
          TAG: /* PostAShift */4,
          _0: param_0
        };
}

function resetPassword(param_0) {
  return {
          TAG: /* ResetPassword */5,
          _0: param_0
        };
}

function signup(param_0) {
  return {
          TAG: /* Signup */6,
          _0: param_0
        };
}

function toUrlParts$5(dashboard) {
  var exit = 0;
  var maybeReferralCode;
  var utmParams;
  var maybeReferralCode$1;
  var utmParams$1;
  if (typeof dashboard === "number") {
    if (dashboard === /* Logout */0) {
      return {
              path: {
                hd: "log-out",
                tl: /* [] */0
              },
              queryArgs: /* [] */0
            };
    } else {
      return {
              path: /* [] */0,
              queryArgs: /* [] */0
            };
    }
  }
  switch (dashboard.TAG | 0) {
    case /* BusinessDashboard */0 :
        return UrlHelpers.UrlParts.prepend(toUrlParts$2(dashboard._0), {
                    path: {
                      hd: "dashboard",
                      tl: /* [] */0
                    },
                    queryArgs: /* [] */0
                  });
    case /* EditShift */1 :
        return {
                path: {
                  hd: "edit-shift",
                  tl: {
                    hd: Curry._1(CommonTypes_Shift.Id.toString, dashboard._0),
                    tl: /* [] */0
                  }
                },
                queryArgs: /* [] */0
              };
    case /* GetApp */2 :
        return UrlHelpers.UrlParts.prepend(toUrlParts$3(dashboard._0), {
                    path: {
                      hd: "get-app",
                      tl: /* [] */0
                    },
                    queryArgs: /* [] */0
                  });
    case /* Login */3 :
        return UrlHelpers.UrlParts.prepend(toUrlParts$4(dashboard._0), {
                    path: {
                      hd: "log-in",
                      tl: /* [] */0
                    },
                    queryArgs: /* [] */0
                  });
    case /* PostAShift */4 :
        return {
                path: {
                  hd: "post-shift",
                  tl: /* [] */0
                },
                queryArgs: Relude_Option.fold(/* [] */0, (function (shiftId) {
                        return Curry._1(UrlHelpers.QueryArgs.fromList, {
                                    hd: [
                                      "copied_shift_id",
                                      Curry._1(CommonTypes_Shift.Id.toString, shiftId)
                                    ],
                                    tl: /* [] */0
                                  });
                      }), dashboard._0)
              };
    case /* ResetPassword */5 :
        return {
                path: {
                  hd: "reset-password",
                  tl: {
                    hd: Curry._1(CommonTypes_Guid.toString, dashboard._0),
                    tl: /* [] */0
                  }
                },
                queryArgs: /* [] */0
              };
    case /* Signup */6 :
        var match = dashboard._0;
        if (match.TAG === /* Business */0) {
          var match$1 = match._0;
          if (match$1.TAG === /* BusinessInfo */0) {
            maybeReferralCode = match$1.maybeReferralCode;
            utmParams = match$1.utmParams;
            exit = 1;
          } else {
            maybeReferralCode = match$1.promoCode;
            utmParams = match$1.utmParams;
            exit = 1;
          }
        } else {
          var match$2 = match._0;
          if (typeof match$2 === "number") {
            return {
                    path: {
                      hd: "worker-registration",
                      tl: {
                        hd: "success",
                        tl: /* [] */0
                      }
                    },
                    queryArgs: /* [] */0
                  };
          }
          if (match$2.TAG === /* PersonalInfo */0) {
            maybeReferralCode$1 = match$2.maybeReferralCode;
            utmParams$1 = match$2.utmParams;
            exit = 2;
          } else {
            maybeReferralCode$1 = match$2.referralCode;
            utmParams$1 = match$2.utmParams;
            exit = 2;
          }
        }
        break;
    
  }
  switch (exit) {
    case 1 :
        var __x = Curry._1(UrlHelpers.QueryArgs.fromList, Relude_Option.fold(/* [] */0, (function (code) {
                    return {
                            hd: [
                              "promo_code",
                              Curry._1(CommonTypes_Business_PromoCode.toString, code)
                            ],
                            tl: /* [] */0
                          };
                  }), maybeReferralCode));
        return {
                path: {
                  hd: "business-registration",
                  tl: /* [] */0
                },
                queryArgs: Relude_List.concat(__x, CommonTypes_UTMParams.toQueryArgs(utmParams))
              };
    case 2 :
        var __x$1 = Curry._1(UrlHelpers.QueryArgs.fromList, Relude_Option.fold(/* [] */0, (function (code) {
                    return {
                            hd: [
                              "promo_code",
                              Curry._1(CommonTypes_Worker_ReferralPromoCode.toString, code)
                            ],
                            tl: /* [] */0
                          };
                  }), maybeReferralCode$1));
        return {
                path: {
                  hd: "worker-registration",
                  tl: /* [] */0
                },
                queryArgs: Relude_List.concat(__x$1, CommonTypes_UTMParams.toQueryArgs(utmParams$1))
              };
    
  }
}

function fromUrlParts$5(parts) {
  var match = CommonTypes_MobileDeepLink.fromURLParts(parts.path);
  if (typeof match === "number") {
    var exit = 0;
    var queryArgs;
    var queryArgs$1;
    var match$1 = parts.path;
    if (!match$1) {
      return /* Welcome */1;
    }
    switch (match$1.hd) {
      case "business-registration" :
          var match$2 = match$1.tl;
          if (match$2) {
            if (match$2.hd === "payment-method") {
              if (match$2.tl) {
                return /* Welcome */1;
              } else {
                return {
                        TAG: /* BusinessDashboard */0,
                        _0: /* Payments */0
                      };
              }
            }
            if (match$2.tl) {
              return /* Welcome */1;
            }
            queryArgs = parts.queryArgs;
            exit = 1;
          } else {
            queryArgs = parts.queryArgs;
            exit = 1;
          }
          break;
      case "dashboard" :
          var path = match$1.tl;
          if (path) {
            return {
                    TAG: /* BusinessDashboard */0,
                    _0: fromUrlParts$2({
                          path: path,
                          queryArgs: parts.queryArgs
                        })
                  };
          } else {
            return {
                    TAG: /* BusinessDashboard */0,
                    _0: {
                      TAG: /* ShiftsList */1,
                      _0: /* Upcoming */1
                    }
                  };
          }
      case "edit-shift" :
          var match$3 = match$1.tl;
          if (match$3 && !match$3.tl) {
            return Relude_Option.fold({
                        TAG: /* BusinessDashboard */0,
                        _0: {
                          TAG: /* ShiftsList */1,
                          _0: /* Upcoming */1
                        }
                      }, editShift, Curry._1(CommonTypes_Shift.Id.fromString, match$3.hd));
          } else {
            return /* Welcome */1;
          }
      case "get-app" :
          return {
                  TAG: /* GetApp */2,
                  _0: fromUrlParts$3({
                        path: match$1.tl,
                        queryArgs: parts.queryArgs
                      })
                };
      case "log-in" :
          var path$1 = match$1.tl;
          if (path$1) {
            return {
                    TAG: /* Login */3,
                    _0: fromUrlParts$4({
                          path: path$1,
                          queryArgs: parts.queryArgs
                        })
                  };
          } else {
            return {
                    TAG: /* Login */3,
                    _0: /* Unknown */2
                  };
          }
      case "log-out" :
          if (match$1.tl) {
            return /* Welcome */1;
          } else {
            return /* Logout */0;
          }
      case "post-shift" :
          if (match$1.tl) {
            return /* Welcome */1;
          } else {
            return {
                    TAG: /* PostAShift */4,
                    _0: Curry._2(Relude_Option.flatMap, CommonTypes_Shift.Id.fromString, Relude_List.head(UrlHelpers.QueryArgs.get("copied_shift_id")(parts.queryArgs)))
                  };
          }
      case "reset-password" :
          var match$4 = match$1.tl;
          if (match$4 && !match$4.tl) {
            return Relude_Option.fold({
                        TAG: /* Login */3,
                        _0: /* Business */0
                      }, resetPassword, Curry._1(CommonTypes_Guid.fromString, match$4.hd));
          } else {
            return /* Welcome */1;
          }
      case "worker-registration" :
          var match$5 = match$1.tl;
          if (match$5) {
            if (match$5.hd === "success") {
              if (match$5.tl) {
                return /* Welcome */1;
              } else {
                return {
                        TAG: /* Signup */6,
                        _0: {
                          TAG: /* Professional */1,
                          _0: /* Success */0
                        }
                      };
              }
            }
            if (match$5.tl) {
              return /* Welcome */1;
            }
            queryArgs$1 = parts.queryArgs;
            exit = 2;
          } else {
            queryArgs$1 = parts.queryArgs;
            exit = 2;
          }
          break;
      default:
        return /* Welcome */1;
    }
    switch (exit) {
      case 1 :
          return {
                  TAG: /* Signup */6,
                  _0: {
                    TAG: /* Business */0,
                    _0: {
                      TAG: /* BusinessInfo */0,
                      maybeReferralCode: Curry._2(Relude_Option.flatMap, CommonTypes_Business_PromoCode.fromString, Relude_List.head(UrlHelpers.QueryArgs.get("promo_code")(queryArgs))),
                      utmParams: CommonTypes_UTMParams.fromQueryArgs(queryArgs)
                    }
                  }
                };
      case 2 :
          return {
                  TAG: /* Signup */6,
                  _0: {
                    TAG: /* Professional */1,
                    _0: {
                      TAG: /* PersonalInfo */0,
                      maybeReferralCode: Curry._2(Relude_Option.flatMap, CommonTypes_Worker_ReferralPromoCode.fromString, Relude_List.head(UrlHelpers.QueryArgs.get("promo_code")(queryArgs$1))),
                      utmParams: CommonTypes_UTMParams.fromQueryArgs(queryArgs$1)
                    }
                  }
                };
      
    }
  } else if (match.TAG === /* Business */0) {
    return {
            TAG: /* GetApp */2,
            _0: /* Business */0
          };
  } else {
    return {
            TAG: /* GetApp */2,
            _0: /* Professional */1
          };
  }
}

function toHref(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great(toUrlParts$5, UrlHelpers.UrlParts.toUrl, param);
              }), (function (param) {
                return "/" + param;
              }), param);
}

var logout = /* Logout */0;

var welcome = /* Welcome */1;

exports.BusinessDashboard = BusinessDashboard;
exports.GetApp = GetApp;
exports.Login = Login;
exports.Signup = Signup;
exports.businessDashboard = businessDashboard;
exports.editShift = editShift;
exports.getApp = getApp;
exports.login = login;
exports.logout = logout;
exports.postAShift = postAShift;
exports.resetPassword = resetPassword;
exports.signup = signup;
exports.welcome = welcome;
exports.toUrlParts = toUrlParts$5;
exports.fromUrlParts = fromUrlParts$5;
exports.toHref = toHref;
/* include Not a pure module */
